/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects'
import getIdentityRegionaleActions, {
    getIdentityRegionaleTypes,
} from '../../redux/identityRegionale/getIdentityRegionale'
import { Get } from '../../serveur/axios'

function* getIdentityRegionaleSagas() {
    try {
        const res = yield Get(`identityRegion`)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(
                    getIdentityRegionaleActions.getIdentityRegionaleSuccess(res)
                ),
            ])
        } else {
            yield put(
                getIdentityRegionaleActions.getIdentityRegionaleFailure(res)
            )
        }
    } catch (error) {
        yield put(
            getIdentityRegionaleActions.getIdentityRegionaleFailure(error)
        )
    }
}

export function* getIdentityRegionale() {
    yield takeLatest(
        getIdentityRegionaleTypes.GET_IDENTITY_REGIONALE_REQUEST,
        getIdentityRegionaleSagas
    )
}
